@let c = charter();
<div class="cards-row">
  <app-charter-company-card
    class="cards-row__wide"
    [company]="c.company"
    [legalNature]="c.legalNature" />
  <app-charter-capital-card
    class="cards-row__narrow"
    [capital]="c.capital"
    [holders]="c.holders"
    [holdersStatus]="c.holdersStatus" />
</div>

<app-charter-holders-card
  [holders]="c.holders"
  [holdersStatus]="c.holdersStatus"
  [receitaOnly]="c.receitaOnly"
  [unitKind]="c.capital.unitKind"
  [legalNature]="c.legalNature"
  [currency]="c.capital.currency"
  [governance]="c.governance" />

<div class="cards-row">
  <app-charter-governance-card
    class="cards-row__half"
    [governance]="c.governance"
    [clauses]="c.clauses"
    [legalNature]="c.legalNature"
    [currency]="c.capital.currency" />
  <app-charter-clauses-card class="cards-row__half" [clauses]="c.clauses" />
</div>

<p class="footnote">
  <i class="pi pi-info-circle" aria-hidden="true"></i>
  Passe o mouse em um valor e clique no ícone de documento para ver o ato, a página e o trecho, e
  abrir o original na página.
  @if (c.computedAt) {
    Vigente montado em {{ c.computedAt | vaultDateTime }}.
  }
  @if (c.receitaCheckedAt) {
    Conferido com a Receita em {{ c.receitaCheckedAt | vaultDateTime }}.
  }
</p>
